import AjaxService, { authHeader } from "services/base/Ajax.service";

class FileService extends AjaxService {
  async getDefaultImages() {
    return this.get("/file/default");
  }

  async getFile(fileId) {
    return this.get(`/file/${fileId}`);
  }

  async updateFile(data) {
    return this.post("/file/update", data);
  }

  async deleteFile(fileId) {
    return this.delete(`/file/${fileId}`);
  }

  async getSignedFileUrl(fileId) {
    return this.get(`/file/${fileId}/url`);
  }

  async downloadFile(fileId) {
    return this.get(`/file/${fileId}/download`, {
      headers: await authHeader(),
      responseType: "blob",
    });
  }

  async uploadFile(data) {
    return this.post("/file/upload", data);
  }
}

export default new FileService();
